  (function () {
    if (window.__configBouquetModalInit) return;
    window.__configBouquetModalInit = true;

    function getModal() {
      return document.getElementById('config-bouquet-modal');
    }

    function getBouquetCustomerPayload() {
      var modal = getModal();
      if (!modal || !modal.dataset) return null;
      var idRaw = (modal.dataset.bouquetCustomerId || '').trim();
      if (!idRaw) return null;
      var idNum = parseInt(idRaw, 10);
      return {
        id: !isNaN(idNum) && idNum > 0 ? idNum : idRaw,
        email: (modal.dataset.bouquetCustomerEmail || '').trim(),
        firstName: (modal.dataset.bouquetCustomerFirstName || '').trim(),
        lastName: (modal.dataset.bouquetCustomerLastName || '').trim(),
      };
    }

    function getOpenButton() {
      return document.getElementById('config-bouquet');
    }

    function getProductsPanel() {
      return document.getElementById('config-bouquet-products-panel');
    }

    function getStoreKey() {
      var modal = getModal();
      if (!modal || !modal.dataset) return 'nl';
      var key = (modal.dataset.configBouquetStoreKey || '').trim().toLowerCase();
      if (!key) return 'nl';
      return key;
    }

    function getPopupOpenTrackEndpoint() {
      var modal = getModal();
      if (!modal || !modal.dataset) return '';
      var explicitEndpoint = (modal.dataset.configBouquetOpenTrackEndpoint || '').trim();
      if (explicitEndpoint) return explicitEndpoint;

      var aiEndpoint = (modal.dataset.configBouquetAiEndpoint || '').trim();
      if (!aiEndpoint) return '';
      try {
        var base = new URL(aiEndpoint, window.location.href);
        return new URL('/api/bouquet-popup-open', base.origin).toString();
      } catch (e) {
        return '';
      }
    }

    function trackPopupOpen(source) {
      var endpoint = getPopupOpenTrackEndpoint();
      if (!endpoint) return;
      var normalizedSource = source === 'direct_link' ? 'direct_link' : 'button';
      var payload = {
        source: normalizedSource,
        storeKey: getStoreKey(),
      };
      try {
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          keepalive: true,
        }).catch(function () {});
      } catch (e) {}
    }

    function syncCartCount() {
      var headerCount = document.querySelector('#cart-drawer-toggle .thb-item-count');
      var badge = document.querySelector('[data-config-bouquet-cart-count]');
      if (!badge || !headerCount) return;
      badge.innerHTML = headerCount.innerHTML;
      var hasSvg = !!headerCount.querySelector('svg');
      var n = parseInt(headerCount.textContent.trim(), 10);
      if (hasSvg || (!isNaN(n) && n > 0)) {
        badge.removeAttribute('data-count-zero');
      } else {
        badge.setAttribute('data-count-zero', 'true');
      }
    }

    function escapeHtml(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function escapeStyleAttr(str) {
      return String(str == null ? '' : str).replace(/"/g, '&quot;');
    }

    function formatPrice(amountStr, currency) {
      var n = parseFloat(amountStr, 10);
      if (isNaN(n)) return amountStr;
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currency || 'EUR',
        }).format(n);
      } catch (err) {
        return amountStr;
      }
    }

    function getRootUrl() {
      var modal = getModal();
      if (modal && modal.dataset && modal.dataset.configBouquetRootUrl) {
        var r = modal.dataset.configBouquetRootUrl;
        return r.endsWith('/') ? r : r + '/';
      }
      if (window.theme && theme.routes && theme.routes.root_url) {
        var t = theme.routes.root_url;
        return t.endsWith('/') ? t : t + '/';
      }
      return '/';
    }

    function getCurrency() {
      var modal = getModal();
      if (modal && modal.dataset && modal.dataset.configBouquetCurrency) {
        return modal.dataset.configBouquetCurrency;
      }
      return 'EUR';
    }

    function getAiPreviewEndpoint() {
      var modal = getModal();
      if (modal && modal.dataset && modal.dataset.configBouquetAiEndpoint) {
        return String(modal.dataset.configBouquetAiEndpoint).trim();
      }
      return 'https://image-generator-topaz-one.vercel.app/api/generate-bouquet-preview';
    }

    function closeProductsPanel() {
      var panel = getProductsPanel();
      if (!panel || !panel.classList.contains('is-open')) return;
      closeColorDrawerImmediate();
      closeMobileBouquetSelectionImmediate();
      var heroBar = document.querySelector('[data-config-bouquet-hero-products-bar]');
      if (heroBar) heroBar.setAttribute('aria-hidden', 'true');
      panel.classList.remove('is-open');
      window.setTimeout(function () {
        panel.setAttribute('hidden', '');
        panel.setAttribute('aria-hidden', 'true');
      }, 320);
    }

    function pickVariant(product) {
      if (!product || !product.variants || !product.variants.length) return null;
      var v = product.variants.find(function (x) {
        return x.available;
      });
      return v || product.variants[0];
    }

    function srcFromImageObj(imgObj) {
      if (!imgObj) return '';
      if (typeof imgObj === 'string') return imgObj;
      return imgObj.src || '';
    }

    function productImageUrl(product, variant) {
      var u = '';
      u = srcFromImageObj(product.featured_image);
      if (!u && product.image) {
        u = srcFromImageObj(product.image);
      }
      if (!u && product.images && product.images.length) {
        u = srcFromImageObj(product.images[0]);
      }
      if (!u && variant) {
        u = srcFromImageObj(variant.featured_image);
        if (!u && variant.image_id != null && product.images && product.images.length) {
          var vidImg = Number(variant.image_id);
          for (var i = 0; i < product.images.length; i++) {
            if (Number(product.images[i].id) === vidImg) {
              u = srcFromImageObj(product.images[i]);
              break;
            }
          }
        }
      }
      u = String(u || '').trim();
      if (!u) return '';
      if (u.indexOf('//') === 0) {
        u = 'https:' + u;
      }
      if (u.indexOf('width=') === -1) {
        u += u.indexOf('?') === -1 ? '?width=300' : '&width=300';
      }
      return u;
    }

    function escapeAttrUrl(url) {
      return String(url).replace(/"/g, '&quot;');
    }

    /** Shopify CDN supports ?width= — cap by hero size on narrow viewports to avoid over-fetching. */
    function heroStemImageUrl(url, maxWidthPx) {
      var u = String(url || '').trim();
      if (!u) return u;
      if (u.indexOf('//') === 0) u = 'https:' + u;
      var w = 1200;
      if (typeof maxWidthPx === 'number' && !isNaN(maxWidthPx) && maxWidthPx > 0) {
        w = Math.min(1200, Math.max(280, Math.round(maxWidthPx)));
      }
      if (/([?&])width=\d+/i.test(u)) {
        u = u.replace(/([?&])width=\d+/gi, '$1width=' + w);
      } else {
        u += u.indexOf('?') === -1 ? '?width=' + w : '&width=' + w;
      }
      return u;
    }

    var currentPanelProducts = [];
    var allPanelProducts = [];
    var colorFacets = [];
    var selectedColorKeys = [];
    var drawerDraftKeys = [];
    var currentPanelCollectionHandle = '';
    var REQUIRED_COLLECTION_PRODUCT_TAG = 'BoeketConfigurator';
    var PRODUCTS_JSON_PAGE_SIZE = 250;
    var PRODUCTS_JSON_MAX_PAGES = 20;
    var collectionProductsCache = Object.create(null);
    var collectionCountsHydrated = false;
    /** When option names are not color-like (e.g. custom labels), infer column from variant data. */
    var collectionColorOptionIndexOverride = null;
    /** Color list came from Liquid collection.filters (same as PLP); match any variant option value. */
    var colorFacetsFromStorefrontFacets = false;

    function productHasRequiredCollectionTag(product) {
      if (!product || !product.tags) return false;
      var tags = product.tags;
      if (typeof tags === 'string') {
        return tags
          .split(',')
          .map(function (t) {
            return String(t || '').trim().toLowerCase();
          })
          .indexOf(REQUIRED_COLLECTION_PRODUCT_TAG.toLowerCase()) !== -1;
      }
      if (Array.isArray(tags)) {
        for (var i = 0; i < tags.length; i++) {
          if (String(tags[i] || '').trim().toLowerCase() === REQUIRED_COLLECTION_PRODUCT_TAG.toLowerCase()) {
            return true;
          }
        }
      }
      return false;
    }

    function productHasAnyAvailableVariant(product) {
      if (!product) return false;
      if (product.available === false) return false;
      if (!Array.isArray(product.variants) || !product.variants.length) return false;
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i] && product.variants[i].available !== false) return true;
      }
      return false;
    }

    function buildCollectionProductsUrl(handle, page) {
      var root = getRootUrl();
      return (
        root +
        'collections/' +
        encodeURIComponent(handle) +
        '/products.json?limit=' +
        PRODUCTS_JSON_PAGE_SIZE +
        '&page=' +
        page
      );
    }

    function fetchAllCollectionProducts(handle) {
      var key = String(handle || '').trim();
      if (!key) return Promise.resolve([]);
      var seenIds = Object.create(null);
      var out = [];

      function loadPage(page) {
        if (page > PRODUCTS_JSON_MAX_PAGES) return Promise.resolve(out);
        return fetch(buildCollectionProductsUrl(key, page))
          .then(function (res) {
            if (!res.ok) throw new Error('Kan producten niet laden');
            return res.json();
          })
          .then(function (data) {
            var rows = Array.isArray(data && data.products) ? data.products : [];
            rows.forEach(function (product) {
              var pid = String(product && product.id != null ? product.id : '');
              if (pid && seenIds[pid]) return;
              if (pid) seenIds[pid] = true;
              out.push(product);
            });
            if (rows.length < PRODUCTS_JSON_PAGE_SIZE) return out;
            return loadPage(page + 1);
          });
      }

      return loadPage(1);
    }

    function getEligibleCollectionProducts(handle) {
      var key = String(handle || '').trim();
      if (!key) return Promise.resolve([]);
      if (!collectionProductsCache[key]) {
        collectionProductsCache[key] = fetchAllCollectionProducts(key).then(function (products) {
          return (products || []).filter(function (product) {
            return productHasRequiredCollectionTag(product) && productHasAnyAvailableVariant(product);
          });
        });
      }
      return collectionProductsCache[key];
    }

    function hydrateCollectionCountBadges() {
      if (collectionCountsHydrated) return;
      collectionCountsHydrated = true;
      var badges = Array.prototype.slice.call(document.querySelectorAll('[data-config-bouquet-count-handle]'));
      if (!badges.length) return;

      var handles = [];
      badges.forEach(function (badge) {
        var h = String((badge.getAttribute('data-config-bouquet-count-handle') || '')).trim();
        if (h && handles.indexOf(h) === -1) handles.push(h);
      });
      if (!handles.length) return;

      Promise.all(
        handles.map(function (handle) {
          return getEligibleCollectionProducts(handle)
            .then(function (products) {
              return { handle: handle, count: products.length };
            })
            .catch(function () {
              return { handle: handle, count: null };
            });
        })
      ).then(function (rows) {
        var byHandle = Object.create(null);
        rows.forEach(function (row) {
          byHandle[row.handle] = row.count;
        });
        badges.forEach(function (badge) {
          var h = String((badge.getAttribute('data-config-bouquet-count-handle') || '')).trim();
          if (!h || byHandle[h] == null) return;
          badge.textContent = byHandle[h] + ' items';
        });
      });
    }

    function normalizeColorKey(raw) {
      return String(raw || '')
        .toLowerCase()
        .trim()
        .replace(/\s+/g, ' ');
    }

    function getBouquetSwatchConfig() {
      var el = document.getElementById('config-bouquet-swatch-config');
      if (!el) {
        return { custom: {}, byCollection: {}, facetColorsByCollection: {}, swatchOptionNames: [] };
      }
      try {
        return JSON.parse(el.textContent.trim());
      } catch (err) {
        return { custom: {}, byCollection: {}, facetColorsByCollection: {}, swatchOptionNames: [] };
      }
    }

    function bouquetSwatchLooksLikeImageUrl(s) {
      var t = String(s || '').trim();
      return /^https?:\/\//i.test(t) || t.indexOf('//cdn.shopify.com') !== -1 || /\.(png|jpe?g|gif|webp|svg)(\?|$)/i.test(t);
    }

    function bouquetCssUrl(u) {
      var s = String(u || '')
        .replace(/\\/g, '\\\\')
        .replace(/'/g, "\\'");
      return "url('" + s + "')";
    }

    /**
     * Resolve a map key for facet labels that differ from map keys (GID, English vs Dutch, "Beige" vs "Crème/Beige").
     * Tries: direct property, normalized full key, then slash-separated segments on each key.
     */
    function bouquetFindMatchingMapKey(map, facetKey, facetLabel) {
      if (!map || typeof map !== 'object') return null;
      var tries = [];
      function add(s) {
        if (s == null || s === '') return;
        var lo = String(s).toLowerCase().trim();
        if (lo && tries.indexOf(lo) === -1) tries.push(lo);
        var nk = normalizeColorKey(s);
        if (nk && tries.indexOf(nk) === -1) tries.push(nk);
      }
      add(facetKey);
      add(facetLabel);
      var ti;
      for (ti = 0; ti < tries.length; ti++) {
        var t = tries[ti];
        if (t && Object.prototype.hasOwnProperty.call(map, t)) return t;
      }
      var k;
      for (k in map) {
        if (!Object.prototype.hasOwnProperty.call(map, k)) continue;
        for (ti = 0; ti < tries.length; ti++) {
          if (!tries[ti]) continue;
          if (normalizeColorKey(k) === normalizeColorKey(tries[ti])) return k;
        }
      }
      for (k in map) {
        if (!Object.prototype.hasOwnProperty.call(map, k)) continue;
        var parts = String(k).split('/');
        var p;
        for (p = 0; p < parts.length; p++) {
          var seg = normalizeColorKey(parts[p]);
          for (ti = 0; ti < tries.length; ti++) {
            if (tries[ti] && seg === normalizeColorKey(tries[ti])) return k;
          }
        }
      }
      return null;
    }

    /** Match embedded byCollection swatch when filter value vs label vs JSON keys differ (metafield / GID). */
    function findColMapEntry(colMap, facetKey, facetLabel) {
      if (!colMap || typeof colMap !== 'object') return null;
      var key = bouquetFindMatchingMapKey(colMap, facetKey, facetLabel);
      return key ? colMap[key] : null;
    }

    function findCustomMapValue(cfg, facetKey, facetLabel) {
      if (!cfg || !cfg.custom) return null;
      var key = bouquetFindMatchingMapKey(cfg.custom, facetKey, facetLabel);
      return key ? cfg.custom[key] : null;
    }

    /**
     * Same CSS variables as facets.css (.filter-color:after): --bg-color, --option-color-image.
     * Data from embedded byCollection (facets-desktop parity) + hardcoded name→hex map in custom (cfg.custom).
     */
    function bouquetSwatchCssVars(collectionHandle, facetKey, facetLabel) {
      var cfg = getBouquetSwatchConfig();
      var colMap = (cfg.byCollection && cfg.byCollection[collectionHandle]) || {};
      var entry = findColMapEntry(colMap, facetKey, facetLabel);

      var color =
        entry && entry.color != null && String(entry.color).trim() !== '' && String(entry.color).toLowerCase() !== 'null' ?
          String(entry.color).trim()
        : null;
      var image =
        entry && entry.image != null && String(entry.image).trim() !== '' && String(entry.image).toLowerCase() !== 'null' ?
          String(entry.image).trim()
        : null;

      var customRaw = null;
      if (!color && !image) {
        customRaw = findCustomMapValue(cfg, facetKey, facetLabel);
        if (customRaw) {
          if (bouquetSwatchLooksLikeImageUrl(customRaw)) {
            image = customRaw;
            color = 'var(--bg-body)';
          } else {
            color = customRaw;
            image = null;
          }
        }
      }

      var parts = [];
      if (image) {
        parts.push('--bg-color:' + (color || 'var(--bg-body)'));
        parts.push('--option-color-image:' + bouquetCssUrl(image));
      } else if (color) {
        parts.push('--bg-color:' + color);
        parts.push('--option-color-image:none');
      } else {
        parts.push('--bg-color:#c8c6c1');
        parts.push('--option-color-image:none');
      }
      return parts.join(';');
    }

    function getOptionNameFromProductOption(opt) {
      if (opt == null) return '';
      if (typeof opt === 'string') return opt;
      return String(opt.name || '');
    }

    /**
     * Shopify collection /products.json uses variant.option1–option3; `variant.options` is often missing.
     */
    function getVariantOptionValues(variant, product) {
      if (!variant) return [];
      if (Array.isArray(variant.options) && variant.options.length) {
        var oa = [];
        for (var oi = 0; oi < variant.options.length; oi++) {
          var x = variant.options[oi];
          oa.push(x == null || x === '' ? '' : String(x));
        }
        return oa;
      }
      var out = [];
      var n = product && product.options && product.options.length ? product.options.length : 3;
      if (variant.option1 != null && variant.option1 !== '') out.push(String(variant.option1));
      if (variant.option2 != null && variant.option2 !== '') out.push(String(variant.option2));
      if (variant.option3 != null && variant.option3 !== '') out.push(String(variant.option3));
      return out.slice(0, n);
    }

    function normalizeFacetColorRows(rows) {
      var map = Object.create(null);
      for (var i = 0; i < rows.length; i++) {
        var r = rows[i];
        var lab = (r.label && String(r.label).trim()) || '';
        if (lab && isLikelySizeOrSkuValue(lab)) continue;
        var k = normalizeColorKey(r.key != null ? r.key : r.label);
        if (!k) continue;
        if (k === 'default' || k === 'default title') continue;
        if (!map[k]) {
          map[k] = {
            key: k,
            label: (r.label && String(r.label).trim()) || k,
            count: 0,
          };
        }
        var c = parseInt(r.count, 10);
        if (!isNaN(c)) map[k].count += c;
      }
      return Object.keys(map)
        .map(function (key) {
          return map[key];
        })
        .sort(function (a, b) {
          return a.label.localeCompare(b.label, undefined, { sensitivity: 'base' });
        });
    }

    function getLightspeedColourMap() {
      var el = document.getElementById('config-bouquet-lightspeed-colour-embedded');
      if (!el) return null;
      try {
        return JSON.parse(el.textContent.trim());
      } catch (err) {
        return null;
      }
    }

    /**
     * Values from embedded product metafield custom.lightspeed_filter_colour (Search & Discovery filter source).
     * Value may be a string or list (JSON array).
     */
    function getLightspeedColourValuesForProduct(product) {
      var m = getLightspeedColourMap();
      if (!m || !product || !product.handle) return null;
      var v = m[product.handle];
      if (v == null || v === '') return null;
      if (Array.isArray(v)) {
        var out = [];
        for (var i = 0; i < v.length; i++) {
          if (v[i] != null && String(v[i]).trim() !== '') out.push(String(v[i]).trim());
        }
        return out.length ? out : null;
      }
      return [String(v).trim()];
    }

    function getColorOptionIndex(product) {
      if (collectionColorOptionIndexOverride != null && collectionColorOptionIndexOverride >= 0) {
        if (product.options && product.options.length > collectionColorOptionIndexOverride) {
          return collectionColorOptionIndexOverride;
        }
        return -1;
      }
      if (!product || !product.options || !product.options.length) return -1;
      var cfg = getBouquetSwatchConfig();
      var extras = cfg.swatchOptionNames || [];
      for (var i = 0; i < product.options.length; i++) {
        var name = getOptionNameFromProductOption(product.options[i]).toLowerCase();
        if (
          /(^|\s)(color|colour|kleur|farbe|couleur)(\s|$)/i.test(name) ||
          /\b(tint|nuance|shade|ton|kleur)\b/i.test(name)
        ) {
          return i;
        }
        for (var e = 0; e < extras.length; e++) {
          if (name === String(extras[e] || '').toLowerCase().trim()) return i;
        }
      }
      if (product.options.length === 1) return 0;
      return -1;
    }

    function isLikelySizeOrSkuValue(s) {
      var t = String(s || '').trim();
      if (!t) return true;
      if (/^default(\s+title)?$/i.test(t)) return true;
      if (/^[\d.,]+\s*(cm|mm|m|in|ft|'|")\s*$/i.test(t)) return true;
      if (/^\d+(\.\d+)?\s*[-–]\s*\d+/.test(t)) return true;
      if (t.length > 45) return true;
      return false;
    }

    /**
     * When strict name matching finds no color column, pick the variant option column with
     * the most diverse short text values (typical for color), not heights/SKUs.
     */
    function inferColorOptionIndexForCollection(products) {
      if (!products || !products.length) return -1;
      var maxJ = 0;
      for (var pi = 0; pi < products.length; pi++) {
        var n = (products[pi].options && products[pi].options.length) || 0;
        if (n > maxJ) maxJ = n;
      }
      if (maxJ <= 0) return -1;

      var bestJ = -1;
      var bestScore = -1;

      for (var j = 0; j < maxJ; j++) {
        var distinct = Object.create(null);
        var samples = [];
        for (var pidx = 0; pidx < products.length; pidx++) {
          var p = products[pidx];
          var variants = p.variants || [];
          for (var vi = 0; vi < variants.length; vi++) {
            var opts = getVariantOptionValues(variants[vi], p);
            if (opts.length <= j) continue;
            var raw = opts[j];
            if (raw == null || String(raw).trim() === '') continue;
            var k = normalizeColorKey(raw);
            if (!k) continue;
            distinct[k] = String(raw).trim();
            if (samples.length < 24) samples.push(String(raw).trim());
          }
        }
        var dcount = Object.keys(distinct).length;
        if (dcount < 2) continue;

        var bad = 0;
        for (var si = 0; si < samples.length; si++) {
          if (isLikelySizeOrSkuValue(samples[si])) bad++;
        }
        var badRatio = samples.length ? bad / samples.length : 0;

        var score = dcount * 20;
        score += Math.min(Object.keys(distinct).length * 3, 60);
        if (badRatio > 0.65) score -= 80;
        if (badRatio > 0.85) score -= 120;

        if (score > bestScore) {
          bestScore = score;
          bestJ = j;
        }
      }
      return bestJ;
    }

    function buildColorFacets(products) {
      var map = Object.create(null);
      for (var i = 0; i < products.length; i++) {
        var p = products[i];
        var lsVals = getLightspeedColourValuesForProduct(p);
        if (lsVals && lsVals.length) {
          for (var li = 0; li < lsVals.length; li++) {
            var rawL = lsVals[li];
            if (rawL == null || String(rawL).trim() === '') continue;
            if (isLikelySizeOrSkuValue(String(rawL).trim())) continue;
            var keyL = normalizeColorKey(rawL);
            if (!keyL) continue;
            if (!map[keyL]) map[keyL] = { label: String(rawL).trim(), count: 0 };
            map[keyL].count += 1;
          }
          continue;
        }
        var idx = getColorOptionIndex(p);
        if (idx < 0) continue;
        var colorsForProduct = Object.create(null);
        var variants = p.variants || [];
        for (var j = 0; j < variants.length; j++) {
          var opts = getVariantOptionValues(variants[j], p);
          if (opts.length <= idx) continue;
          var raw = opts[idx];
          if (raw == null || String(raw).trim() === '') continue;
          if (isLikelySizeOrSkuValue(String(raw).trim())) continue;
          var key = normalizeColorKey(raw);
          if (!key) continue;
          colorsForProduct[key] = String(raw).trim();
        }
        var ckeys = Object.keys(colorsForProduct);
        for (var c = 0; c < ckeys.length; c++) {
          var kk = ckeys[c];
          if (!map[kk]) map[kk] = { label: colorsForProduct[kk], count: 0 };
          map[kk].count += 1;
        }
      }
      return Object.keys(map)
        .map(function (k) {
          return { key: k, label: map[k].label, count: map[k].count };
        })
        .sort(function (a, b) {
          return a.label.localeCompare(b.label, undefined, { sensitivity: 'base' });
        });
    }

    function productMatchesColorKeys(product, keys) {
      if (!keys || !keys.length) return true;
      var lsVals = getLightspeedColourValuesForProduct(product);
      if (lsVals && lsVals.length) {
        for (var lx = 0; lx < lsVals.length; lx++) {
          if (keys.indexOf(normalizeColorKey(lsVals[lx])) !== -1) return true;
        }
        return false;
      }
      var variants = product.variants || [];
      if (colorFacetsFromStorefrontFacets) {
        for (var jf = 0; jf < variants.length; jf++) {
          var optsF = getVariantOptionValues(variants[jf], product);
          for (var oi = 0; oi < optsF.length; oi++) {
            if (keys.indexOf(normalizeColorKey(optsF[oi])) !== -1) return true;
          }
        }
        return false;
      }
      var idx = getColorOptionIndex(product);
      if (idx < 0) return false;
      for (var j = 0; j < variants.length; j++) {
        var opts = getVariantOptionValues(variants[j], product);
        if (opts.length <= idx) continue;
        var key = normalizeColorKey(opts[idx]);
        if (keys.indexOf(key) !== -1) return true;
      }
      return false;
    }

    function countProductsMatchingColorKeys(products, keys) {
      if (!products || !products.length) return 0;
      if (!keys || !keys.length) return products.length;
      var n = 0;
      for (var i = 0; i < products.length; i++) {
        if (productMatchesColorKeys(products[i], keys)) n += 1;
      }
      return n;
    }

    function setColorFilterButtonsEnabled(on) {
      document.querySelectorAll('[data-config-bouquet-color-filter]').forEach(function (btn) {
        btn.disabled = !on;
      });
    }

    function updateColorFilterButtonUi() {
      var n = selectedColorKeys.length;
      var suffix = n ? ' (' + n + ')' : '';
      document.querySelectorAll('[data-config-bouquet-color-filter-label]').forEach(function (el) {
        el.textContent = 'Filtre de couleur' + suffix;
      });
    }

    function renderFilterChips() {
      var wrap = document.querySelector('[data-config-bouquet-filter-chips]');
      if (!wrap) return;
      if (!selectedColorKeys.length) {
        wrap.innerHTML = '';
        wrap.hidden = true;
        return;
      }
      wrap.hidden = false;
      var labelByKey = Object.create(null);
      for (var i = 0; i < colorFacets.length; i++) {
        labelByKey[colorFacets[i].key] = colorFacets[i].label;
      }
      wrap.innerHTML = selectedColorKeys
        .map(function (key) {
          var label = labelByKey[key] || key;
          return (
            '<button type="button" class="config-bouquet-modal__filter-chip" data-config-bouquet-filter-chip-remove="' +
            encodeURIComponent(key) +
            '">' +
            escapeHtml(label) +
            ' <span aria-hidden="true">×</span></button>'
          );
        })
        .join('');
    }

    function applyColorFiltersAndRender() {
      var filtered;
      if (!selectedColorKeys.length) {
        filtered = allPanelProducts.slice();
      } else {
        filtered = allPanelProducts.filter(function (p) {
          return productMatchesColorKeys(p, selectedColorKeys);
        });
      }
      renderProducts(filtered);
      renderFilterChips();
      updateColorFilterButtonUi();
    }

    function closeColorDrawer() {
      var d = document.getElementById('config-bouquet-color-drawer');
      if (!d) return;
      d.classList.remove('is-open');
      window.setTimeout(function () {
        d.setAttribute('hidden', '');
        d.setAttribute('aria-hidden', 'true');
      }, 320);
    }

    function closeColorDrawerImmediate() {
      var d = document.getElementById('config-bouquet-color-drawer');
      if (!d) return;
      d.classList.remove('is-open');
      d.setAttribute('hidden', '');
      d.setAttribute('aria-hidden', 'true');
    }

    function getCheckedColorKeysFromDrawer() {
      var drawer = document.getElementById('config-bouquet-color-drawer');
      if (!drawer) return [];
      var inputs = drawer.querySelectorAll('input[data-config-bouquet-color-option]');
      var keys = [];
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].checked) keys.push(inputs[i].value);
      }
      return keys;
    }

    function updateDrawerApplyButtonLabel() {
      var keys = getCheckedColorKeysFromDrawer();
      drawerDraftKeys = keys;
      var n = countProductsMatchingColorKeys(allPanelProducts, keys);
      var btn = document.querySelector('[data-config-bouquet-color-drawer-apply]');
      if (btn) btn.textContent = 'MONTRER ' + n + ' RÉSULTATS';
    }

    function renderColorDrawerList() {
      var listEl = document.querySelector('[data-config-bouquet-color-drawer-list]');
      if (!listEl) return;
      if (!colorFacets.length) {
        listEl.innerHTML =
          '<p class="config-bouquet-color-drawer__empty">No color options in this collection.</p>';
        return;
      }
      var parts = [
        '<div class="facets"><div class="thb-filter"><ul class="list-color config-bouquet-color-drawer__facet-ul">',
      ];
      var sortedFacets = colorFacets.slice().sort(function (a, b) {
        var ac = parseInt(a && a.count, 10);
        var bc = parseInt(b && b.count, 10);
        if (isNaN(ac)) ac = 0;
        if (isNaN(bc)) bc = 0;
        if (bc !== ac) return bc - ac;
        return String((a && a.label) || '').localeCompare(String((b && b.label) || ''), undefined, {
          sensitivity: 'base',
        });
      });
      sortedFacets.forEach(function (f, idx) {
        var id = 'config-bouquet-color-opt-' + idx;
        var checked = drawerDraftKeys.indexOf(f.key) !== -1 ? ' checked' : '';
        var vars = bouquetSwatchCssVars(currentPanelCollectionHandle, f.key, f.label);
        parts.push(
          '<li>' +
            '<input type="checkbox" class="config-bouquet-color-drawer__native-cb" id="' +
            id +
            '"' +
            checked +
            ' data-config-bouquet-color-option value="' +
            escapeHtml(f.key) +
            '">' +
            '<label for="' +
            id +
            '" class="facet-checkbox config-bouquet-color-drawer__facet-label" style="' +
            escapeStyleAttr(vars) +
            '">' +
            '<span class="filter-color"></span>' +
            '<span class="filter-name">' +
            escapeHtml(f.label) +
            '</span>' +
            '<span class="count">(' +
            f.count +
            ')</span>' +
            '</label>' +
            '</li>'
        );
      });
      parts.push('</ul></div></div>');
      listEl.innerHTML = parts.join('');
    }

    function openColorDrawer() {
      var d = document.getElementById('config-bouquet-color-drawer');
      if (!d) return;
      drawerDraftKeys = selectedColorKeys.slice();
      renderColorDrawerList();
      updateDrawerApplyButtonLabel();
      d.removeAttribute('hidden');
      d.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () {
        d.classList.add('is-open');
      });
    }

    function onColorDrawerApply() {
      selectedColorKeys = getCheckedColorKeysFromDrawer();
      closeColorDrawer();
      applyColorFiltersAndRender();
    }

    var bouquetSelections = Object.create(null);
    /** Max stems / line items total (hero preview + cart). */
    var BOUQUET_MAX_FLOWERS = 25;
    var aiPreviewLoading = false;
    var aiProgressSimTimer = null;

    function clearAiProgressSim() {
      if (aiProgressSimTimer) {
        clearInterval(aiProgressSimTimer);
        aiProgressSimTimer = null;
      }
    }

    function setAiProgressBars(percent) {
      var modal = getModal();
      if (!modal) return;
      var p = Math.max(0, Math.min(100, Math.round(percent)));
      modal.querySelectorAll('[data-config-bouquet-ai-progress-fill]').forEach(function (el) {
        el.style.width = p + '%';
      });
      modal.querySelectorAll('[data-config-bouquet-ai-progress-track]').forEach(function (el) {
        el.setAttribute('aria-valuenow', String(p));
      });
    }

    function startAiProgressSimulation() {
      clearAiProgressSim();
      var softCap = 75;
      var hardCap = 97;
      /** After soft cap, keep a bounded “slow then crawl” zone (was 78→88 before softCap moved). */
      var slowCreepUntil = 88;
      var v = 6;
      setAiProgressBars(v);
      aiProgressSimTimer = window.setInterval(function () {
        if (v >= hardCap) {
          v = hardCap;
          setAiProgressBars(v);
          return;
        }
        /* Move faster up front, then keep a slow creep so it never feels stuck. */
        if (v < 55) {
          v += Math.random() * 5.2 + 2.1;
        } else if (v < softCap) {
          v += Math.random() * 2.8 + 1.1;
        } else if (v < slowCreepUntil) {
          v += Math.random() * 1.2 + 0.45;
        } else {
          v += Math.random() * 0.22 + 0.04;
        }
        if (v > hardCap) v = hardCap;
        setAiProgressBars(v);
      }, 520);
    }

    function setAiPreviewButtonLabelText(btn, text) {
      if (!btn || !text) return;
      var labelEl = btn.querySelector('.config-bouquet-modal__ai-preview-btn-label');
      if (labelEl) {
        labelEl.textContent = text;
      } else {
        btn.textContent = text;
      }
    }

    function resetAiPopupHeroToLoading() {
      var modal = getModal();
      if (!modal) return;
      var popupResult = modal.querySelector('[data-config-bouquet-ai-popup-result]');
      var popupLoading = modal.querySelector('[data-config-bouquet-ai-popup-loading]');
      if (popupResult) {
        popupResult.hidden = true;
        popupResult.removeAttribute('src');
      }
      if (popupLoading) popupLoading.hidden = false;
    }

    function showAiPopupResultImage(imageDataUrl) {
      var modal = getModal();
      if (!modal || !imageDataUrl) return;
      var popupResult = modal.querySelector('[data-config-bouquet-ai-popup-result]');
      var popupLoading = modal.querySelector('[data-config-bouquet-ai-popup-loading]');
      if (popupResult) {
        popupResult.setAttribute('src', imageDataUrl);
        popupResult.hidden = false;
      }
      if (popupLoading) popupLoading.hidden = true;
    }

    function showAiGeneratingUi() {
      var modal = getModal();
      if (!modal) return;
      resetAiPopupHeroToLoading();
      modal.setAttribute('data-ai-generating', 'true');
      setAiStatus('', false);
      modal.querySelectorAll('[data-config-bouquet-ai-progress]').forEach(function (w) {
        w.removeAttribute('hidden');
      });
      modal.querySelectorAll('[data-config-bouquet-ai-preview]').forEach(function (btn) {
        setAiPreviewButtonLabelText(btn, 'GENEREREN');
      });
      var popup = modal.querySelector('[data-config-bouquet-ai-popup]');
      if (popup) {
        popup.hidden = false;
        popup.setAttribute('aria-hidden', 'false');
      }
      startAiProgressSimulation();
    }

    function hideAiProgressUi(opts) {
      opts = opts || {};
      var closePopup = opts.closePopup !== false;
      var modal = getModal();
      if (!modal) return;
      modal.removeAttribute('data-ai-generating');
      clearAiProgressSim();
      modal.querySelectorAll('[data-config-bouquet-ai-progress]').forEach(function (w) {
        w.setAttribute('hidden', '');
      });
      modal.querySelectorAll('[data-config-bouquet-ai-progress-fill]').forEach(function (el) {
        el.style.width = '0%';
      });
      modal.querySelectorAll('[data-config-bouquet-ai-progress-track]').forEach(function (el) {
        el.setAttribute('aria-valuenow', '0');
      });
      if (closePopup) {
        var popup = modal.querySelector('[data-config-bouquet-ai-popup]');
        if (popup) {
          popup.hidden = true;
          popup.setAttribute('aria-hidden', 'true');
        }
      }
    }

    function restoreAiPreviewButtonLabels() {
      var modal = getModal();
      if (!modal) return;
      modal.querySelectorAll('[data-config-bouquet-ai-preview]').forEach(function (btn) {
        var lab = btn.getAttribute('data-config-bouquet-ai-btn-idle-label');
        if (lab) setAiPreviewButtonLabelText(btn, lab);
      });
    }

    function setAiPreviewButtonsHidden(hidden) {
      var modal = getModal();
      if (!modal) return;
      modal.querySelectorAll('[data-config-bouquet-ai-preview]').forEach(function (btn) {
        if (!btn) return;
        if (hidden) btn.setAttribute('hidden', '');
        else btn.removeAttribute('hidden');
      });
    }

    var iconTrash =
      '<img src="https://cdn.shopify.com/s/files/1/0642/5460/7459/files/TrashSimple.png?v=1775154987" height="16px" width="16px" />';
    var iconPlus =
      '<img src="https://cdn.shopify.com/s/files/1/0642/5460/7459/files/Plus.png?v=1775155107" height="16px" width="16px" alt="" />';

    function buildSelectionSignature() {
      return Object.keys(bouquetSelections)
        .filter(function (k) {
          return bouquetSelections[k] && bouquetSelections[k].quantity > 0;
        })
        .sort()
        .map(function (k) {
          return k + ':' + bouquetSelections[k].quantity;
        })
        .join('|');
    }

    function selectedProductsForAi() {
      return Object.keys(bouquetSelections)
        .filter(function (k) {
          return bouquetSelections[k] && bouquetSelections[k].quantity > 0;
        })
        .sort()
        .map(function (k) {
          var line = bouquetSelections[k];
          var h = 0;
          if (typeof line.heightCm === 'number' && !isNaN(line.heightCm) && line.heightCm > 0) {
            h = line.heightCm;
          } else {
            h = parseHeightCmFromTitle(line.title || '');
          }
          return {
            title: line.title || 'Flower',
            quantity: line.quantity || 1,
            heightCm: h > 0 ? h : '',
            imageUrl: line.imageUrl || '',
          };
        });
    }

    function setAiStatus(message, isError) {
      var modal = getModal();
      if (!modal) return;
      var statusEls = modal.querySelectorAll('[data-config-bouquet-ai-status]');
      if (!statusEls || !statusEls.length) return;
      statusEls.forEach(function (statusEl) {
        statusEl.textContent = message || '';
        if (isError) statusEl.setAttribute('data-error', 'true');
        else statusEl.removeAttribute('data-error');
      });
    }

    function clearAiPreview(opts) {
      var modal = getModal();
      if (!modal) return;
      var aiImg = modal.querySelector('[data-config-bouquet-hero-ai]');
      modal.removeAttribute('data-ai-preview-active');
      delete modal.dataset.aiPreviewSelectionSignature;
      if (aiImg) {
        aiImg.hidden = true;
        aiImg.removeAttribute('src');
      }
      resetAiPopupHeroToLoading();
      clearAiProgressSim();
      hideAiProgressUi();
      setAiPreviewButtonsHidden(false);
      restoreAiPreviewButtonLabels();
      if (!opts || !opts.keepStatus) {
        setAiStatus('', false);
      }
    }

    function renderAiPreview(imageDataUrl) {
      var modal = getModal();
      if (!modal) return;
      var aiImg = modal.querySelector('[data-config-bouquet-hero-ai]');
      if (!aiImg || !imageDataUrl) return;
      aiImg.setAttribute('src', imageDataUrl);
      aiImg.hidden = false;
      showAiPopupResultImage(imageDataUrl);
      modal.setAttribute('data-ai-preview-active', 'true');
      modal.dataset.aiPreviewSelectionSignature = buildSelectionSignature();
      setAiPreviewButtonsHidden(true);
    }

    function updateAiControls() {
      var modal = getModal();
      if (!modal) return;
      var s = sumBouquet();
      var hasSelection = s.count > 0;
      var btns = modal.querySelectorAll('[data-config-bouquet-ai-preview]');
      if (!btns || !btns.length) return;
      btns.forEach(function (btn) {
        btn.disabled = !hasSelection || aiPreviewLoading;
      });
    }

    function requestAiBouquetPreview() {
      var modal = getModal();
      if (!modal || aiPreviewLoading) return;
      var products = selectedProductsForAi();
      if (!products.length) {
        setAiStatus('Commencez par ajouter des fleurs pour créer un aperçu IA.', true);
        return;
      }
      var currentSignature = buildSelectionSignature();
      var aiImg = modal.querySelector('[data-config-bouquet-hero-ai]');
      if (
        currentSignature &&
        modal.dataset.aiPreviewSelectionSignature === currentSignature &&
        aiImg &&
        aiImg.getAttribute('src')
      ) {
        renderAiPreview(aiImg.getAttribute('src'));
        setAiStatus('', false);
        return;
      }
      var endpoint = getAiPreviewEndpoint();
      if (!endpoint) {
        setAiStatus('AI endpoint ontbreekt.', true);
        return;
      }

      aiPreviewLoading = true;
      showAiGeneratingUi();
      updateAiControls();

      var aiBody = {
        selectedProducts: products,
        aspectRatio: '1:1',
        sampleCount: 1,
        storeKey: getStoreKey(),
      };
      var cust = getBouquetCustomerPayload();
      if (cust) aiBody.customer = cust;

      fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(aiBody),
      })
        .then(function (res) {
          return res
            .json()
            .catch(function () {
              return {};
            })
            .then(function (body) {
              if (!res.ok || !body || !body.ok) {
                var msg = (body && body.error) || 'AI preview mislukt.';
                throw new Error(msg);
              }
              return body;
            });
        })
        .then(function (body) {
          if (!body.imageDataUrl) throw new Error('Geen afbeelding ontvangen van AI API.');
          clearAiProgressSim();
          setAiProgressBars(100);
          /* Let the fill animate to 100%, then hide bar and restore labels. */
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              renderAiPreview(body.imageDataUrl);
              setAiStatus('', false);
            });
          });
          window.setTimeout(function () {
            /* Keep AI popup open with result; only reset progress UI inside it. */
            hideAiProgressUi({ closePopup: false });
            restoreAiPreviewButtonLabels();
            aiPreviewLoading = false;
            updateAiControls();
            updateBouquetHeroPreview();
            updateBouquetChrome();
          }, 480);
        })
        .catch(function (err) {
          clearAiProgressSim();
          hideAiProgressUi();
          restoreAiPreviewButtonLabels();
          setAiStatus(err && err.message ? err.message : 'AI preview mislukt.', true);
          aiPreviewLoading = false;
          updateAiControls();
        });
    }

    function clearBouquetStaging() {
      bouquetSelections = Object.create(null);
      clearAiPreview();
      updateBouquetChrome();
      refreshProductListFromCache();
    }

    function resetBouquetConfigurator() {
      bouquetSelections = Object.create(null);
      currentPanelProducts = [];
      allPanelProducts = [];
      colorFacets = [];
      collectionColorOptionIndexOverride = null;
      colorFacetsFromStorefrontFacets = false;
      selectedColorKeys = [];
      drawerDraftKeys = [];
      currentPanelCollectionHandle = '';
      closeColorDrawerImmediate();
      closeMobileBouquetSelectionImmediate();
      setColorFilterButtonsEnabled(false);
      var chips = document.querySelector('[data-config-bouquet-filter-chips]');
      if (chips) {
        chips.innerHTML = '';
        chips.hidden = true;
      }
      var list = document.querySelector('[data-config-bouquet-products-list]');
      if (list) list.innerHTML = '';
      clearAiPreview();
      updateColorFilterButtonUi();
      updateBouquetChrome();
    }

    function findProductForVariant(vid) {
      var idStr = String(vid);
      var pool = allPanelProducts.length ? allPanelProducts : currentPanelProducts;
      for (var i = 0; i < pool.length; i++) {
        var p = pool[i];
        if (!p.variants) continue;
        for (var j = 0; j < p.variants.length; j++) {
          if (String(p.variants[j].id) === idStr) {
            return { product: p, variant: p.variants[j] };
          }
        }
      }
      return null;
    }

    function parseHeightCmFromString(s) {
      if (s == null || s === '') return 0;
      var m = String(s).match(/(\d+(?:[.,]\d+)?)/);
      if (!m) return 0;
      return parseFloat(m[1].replace(',', '.')) || 0;
    }

    /** e.g. "Delphinium 79 cm White" when cus.hgt missing from Storefront JSON. */
    function parseHeightCmFromTitle(title) {
      if (title == null || title === '') return 0;
      var re = /(\d+(?:[.,]\d+)?)\s*cm\b/gi;
      var maxV = 0;
      var m;
      while ((m = re.exec(String(title))) !== null) {
        var v = parseFloat(m[1].replace(',', '.')) || 0;
        if (v > maxV) maxV = v;
      }
      return maxV;
    }

    function coerceHeightCm(val) {
      if (val == null || val === '') return 0;
      if (typeof val === 'number' && !isNaN(val) && val > 0) return val;
      return parseHeightCmFromString(String(val));
    }

    /**
     * Height for hero stems: trust stored line.heightCm first, then cus.hgt via embedded map
     * (products.json often has no metafields), then live product, then title.
     */
    function resolveHeightCmForBouquetLine(line, found) {
      if (!line) return 0;
      var h0 = coerceHeightCm(line.heightCm);
      if (h0 > 0) return h0;
      var map = getEmbeddedHeightMap();
      var ph = line.productHandle;
      if (ph && map && map[ph] != null && map[ph] !== '') {
        var hm = parseHeightCmFromString(String(map[ph]));
        if (hm > 0) return hm;
      }
      if (found && found.product) {
        var hp = heightCmFromProduct(found.product);
        if (hp > 0) return hp;
      }
      if (line.title) {
        var ht = parseHeightCmFromTitle(line.title);
        if (ht > 0) return ht;
      }
      return 0;
    }

    function heightCmFromProduct(product) {
      if (!product) return 0;
      var raw = extractProductHeightHgt(product);
      if (raw) return parseHeightCmFromString(raw);
      var map = getEmbeddedHeightMap();
      if (map && product.handle && map[product.handle] != null && map[product.handle] !== '') {
        return parseHeightCmFromString(map[product.handle]);
      }
      var fromTitle = parseHeightCmFromTitle(product.title);
      if (fromTitle > 0) return fromTitle;
      return 0;
    }

    function bouquetLineFromFound(found) {
      var p = found.product;
      var v = found.variant;
      var cur = getCurrency();
      var line = {
        variantId: parseInt(v.id, 10),
        quantity: 0,
        title: p.title,
        priceDisplay: formatPrice(v.price, cur),
        priceNumeric: parseFloat(v.price, 10) || 0,
        imageUrl: productImageUrl(p, v),
        productUrl: p.url || '',
        productHandle: p.handle ? String(p.handle) : '',
        heightCm: 0,
      };
      line.heightCm = resolveHeightCmForBouquetLine(line, found);
      return line;
    }

    function addVariantToBouquet(vid) {
      var found = findProductForVariant(vid);
      if (!found || !found.variant.available) return;
      if (sumBouquet().count >= BOUQUET_MAX_FLOWERS) return;
      var key = String(vid);
      if (!bouquetSelections[key]) {
        bouquetSelections[key] = bouquetLineFromFound(found);
      }
      bouquetSelections[key].quantity += 1;
      syncSelectionPrice(key);
      refreshProductListFromCache();
      updateBouquetChrome();
    }

    function syncSelectionPrice(key) {
      var line = bouquetSelections[key];
      if (!line) return;
      var found = findProductForVariant(key);
      var cur = getCurrency();
      if (found) {
        var v = found.variant;
        var p = found.product;
        line.priceDisplay = formatPrice(v.price, cur);
        line.priceNumeric = parseFloat(v.price, 10) || 0;
        if (p.handle) line.productHandle = String(p.handle);
        var hp = heightCmFromProduct(p);
        var ht = line.title ? parseHeightCmFromTitle(line.title) : 0;
        line.heightCm = hp > 0 ? hp : ht;
      } else {
        var map = getEmbeddedHeightMap();
        var hm = 0;
        if (line.productHandle && map && map[line.productHandle] != null && map[line.productHandle] !== '') {
          hm = parseHeightCmFromString(String(map[line.productHandle]));
        }
        var ht2 = line.title ? parseHeightCmFromTitle(line.title) : 0;
        if (hm > 0) line.heightCm = hm;
        else if (ht2 > 0) line.heightCm = ht2;
      }
    }

    function removeVariantFromBouquet(vid) {
      var key = String(vid);
      delete bouquetSelections[key];
      refreshProductListFromCache();
      updateBouquetChrome();
    }

    function decrementVariantInBouquet(vid) {
      var key = String(vid);
      if (!bouquetSelections[key] || bouquetSelections[key].quantity <= 0) return;
      if (bouquetSelections[key].quantity > 1) {
        bouquetSelections[key].quantity -= 1;
        syncSelectionPrice(key);
        refreshProductListFromCache();
        updateBouquetChrome();
      } else {
        removeVariantFromBouquet(vid);
      }
    }

    function incrementVariantInBouquet(vid) {
      var key = String(vid);
      var found = findProductForVariant(vid);
      if (!found || !found.variant.available) return;
      if (sumBouquet().count >= BOUQUET_MAX_FLOWERS) return;
      if (!bouquetSelections[key]) {
        bouquetSelections[key] = bouquetLineFromFound(found);
      }
      bouquetSelections[key].quantity += 1;
      syncSelectionPrice(key);
      refreshProductListFromCache();
      updateBouquetChrome();
    }

    function sumBouquet() {
      var count = 0;
      var total = 0;
      Object.keys(bouquetSelections).forEach(function (k) {
        var s = bouquetSelections[k];
        if (s.quantity > 0) {
          count += s.quantity;
          total += s.priceNumeric * s.quantity;
        }
      });
      return { count: count, total: total };
    }

    /** Slot indices (left→right) in mountain order: center, −1, +1, −2, +2, … — tallest maps to center. */
    function mountainSlotOrder(n) {
      if (n <= 0) return [];
      var mid = Math.floor(n / 2);
      var slots = [mid];
      for (var d = 1; slots.length < n; d++) {
        if (mid - d >= 0) slots.push(mid - d);
        if (slots.length >= n) break;
        if (mid + d < n) slots.push(mid + d);
      }
      return slots;
    }

    function buildBouquetStemEntries() {
      var out = [];
      var keys = Object.keys(bouquetSelections).sort();
      for (var ki = 0; ki < keys.length; ki++) {
        var k = keys[ki];
        var line = bouquetSelections[k];
        if (!line || line.quantity <= 0) continue;
        var url = String(line.imageUrl || '').trim();
        if (!url) continue;
        var foundLine = findProductForVariant(k);
        var h = resolveHeightCmForBouquetLine(line, foundLine);
        for (var q = 0; q < line.quantity; q++) {
          if (out.length >= BOUQUET_MAX_FLOWERS) return out;
          out.push({ url: url, heightCm: h });
        }
      }
      return out;
    }

    function arrangeStemsFan(entries) {
      var n = entries.length;
      if (n === 0) return [];
      var sorted = entries.slice().sort(function (a, b) {
        var hb = typeof b.heightCm === 'number' && !isNaN(b.heightCm) ? b.heightCm : 0;
        var ha = typeof a.heightCm === 'number' && !isNaN(a.heightCm) ? a.heightCm : 0;
        if (hb !== ha) return hb - ha;
        return 0;
      });
      var slots = mountainSlotOrder(n);
      var row = new Array(n);
      for (var i = 0; i < n; i++) {
        row[slots[i]] = sorted[i];
      }
      return row;
    }

    function updateBouquetHeroPreview() {
      var modal = getModal();
      if (!modal) return;
      var defaultEl = modal.querySelector('[data-config-bouquet-hero-default]');
      var liveEl = modal.querySelector('[data-config-bouquet-hero-live]');
      var stemsEl = modal.querySelector('[data-config-bouquet-hero-stems]');
      var vaseEl = modal.querySelector('[data-config-bouquet-hero-vase]');
      var aiImg = modal.querySelector('[data-config-bouquet-hero-ai]');
      if (!defaultEl || !liveEl || !stemsEl) return;
      if (modal.getAttribute('data-ai-preview-active') === 'true' && aiImg && !aiImg.hidden) {
        defaultEl.hidden = true;
        defaultEl.setAttribute('aria-hidden', 'true');
        liveEl.hidden = true;
        liveEl.setAttribute('aria-hidden', 'true');
        aiImg.hidden = false;
        return;
      }
      if (aiImg) aiImg.hidden = true;

      var stemEntries = buildBouquetStemEntries();
      var placed = arrangeStemsFan(stemEntries);
      var vaseUrl = String(modal.dataset.configBouquetVaseUrl || '').trim();

      if (vaseEl) {
        if (vaseUrl) {
          if (vaseEl.getAttribute('src') !== vaseUrl) {
            vaseEl.setAttribute('src', vaseUrl);
          }
          vaseEl.hidden = false;
        } else {
          vaseEl.hidden = true;
          vaseEl.removeAttribute('src');
        }
      }

      if (placed.length === 0) {
        liveEl.hidden = true;
        liveEl.setAttribute('aria-hidden', 'true');
        defaultEl.hidden = false;
        defaultEl.removeAttribute('aria-hidden');
        stemsEl.innerHTML = '';
        stemsEl.style.removeProperty('--hero-stems-nudge-up');
        return;
      }

      defaultEl.hidden = true;
      defaultEl.setAttribute('aria-hidden', 'true');
      liveEl.hidden = false;
      liveEl.setAttribute('aria-hidden', 'false');

      var n = placed.length;
      var isNarrowHero =
        typeof window !== 'undefined' &&
        window.matchMedia &&
        window.matchMedia('(max-width: 768px)').matches;
      /** Must match mobile CSS hero height (with selections) when layout not measured yet (e.g. first paint). */
      var MOBILE_HERO_FALLBACK_PX = 215;
      var heroEl = modal.querySelector('.config-bouquet-modal__hero');
      var heroRect = heroEl ? heroEl.getBoundingClientRect() : null;
      var heroH =
        heroRect && heroRect.height > 0 ? heroRect.height : isNarrowHero ? MOBILE_HERO_FALLBACK_PX : 520;
      var heroW =
        heroRect && heroRect.width > 0
          ? heroRect.width
          : isNarrowHero && typeof window !== 'undefined' && window.innerWidth
            ? Math.min(Math.max(window.innerWidth - 32, 280), 430)
            : 520;
      /* Narrow hero (~215px with selections): scale vs 215 reference; anchor bases in the shorter mobile box. */
      var narrowScale = isNarrowHero ? Math.max(0.45, Math.min(1, heroH / 215)) : 1;
      var anchorB = isNarrowHero ? Math.max(5, Math.min(7, Math.round(6 * narrowScale))) : 10;
      var stemW = Math.max(
        26,
        Math.min(42, Math.round(112 / Math.pow(Math.max(n, 1), 0.2)))
      );
      if (n > 5) {
        stemW = Math.max(24, Math.round(stemW * 0.92));
      }
      var maxH = 0;
      var hasAnyHeight = false;
      for (var mh = 0; mh < n; mh++) {
        var hh = placed[mh].heightCm;
        if (typeof hh === 'string') hh = parseHeightCmFromString(hh);
        if (typeof hh === 'number' && !isNaN(hh) && hh > 0) {
          hasAnyHeight = true;
          if (hh > maxH) maxH = hh;
        }
      }
      var STEM_TALL_PX;
      var STEM_PEAK_CAP;
      var STEM_MIN_PX;
      var stemPxFloor;
      if (isNarrowHero) {
        /* Mobile hero ~215px: stem heights scale with box; slightly more of hero height than old 164px tuning. */
        STEM_TALL_PX = Math.round(heroH * 0.88);
        STEM_PEAK_CAP = Math.round(heroH * 0.94);
        STEM_MIN_PX = Math.round(heroH * 0.5);
        stemPxFloor = Math.round(heroH * 0.42);
      } else {
        STEM_TALL_PX = Math.round(heroH * 2.25);
        STEM_PEAK_CAP = Math.round(heroH * 2.4);
        STEM_MIN_PX = Math.round(heroH * 1.36);
        stemPxFloor = Math.round(heroH * 1.2);
      }
      var cx = (n - 1) / 2;
      var centerIdx = Math.floor(n / 2);
      /* Straight side-by-side layout: no fan rotation, fixed X spacing between stems. */
      var maxSpanPx = Math.round(heroW * (isNarrowHero ? 0.68 : 0.64));
      var stepPx = n > 1 ? Math.max(14, Math.min(40, Math.round(maxSpanPx / (n - 1)))) : 0;
      var peakIdx = centerIdx;
      if (hasAnyHeight && maxH > 0) {
        var bestPeakD = Infinity;
        for (var pi = 0; pi < n; pi++) {
          var ph0 = placed[pi].heightCm;
          if (typeof ph0 === 'string') ph0 = parseHeightCmFromString(ph0);
          if (typeof ph0 !== 'number' || isNaN(ph0) || ph0 <= 0) continue;
          if (ph0 < maxH - 0.5) continue;
          var d0 = Math.abs(pi - centerIdx);
          if (d0 < bestPeakD) {
            bestPeakD = d0;
            peakIdx = pi;
          }
        }
      }
      var parts = [];
      for (var i = 0; i < n; i++) {
        var baseShiftX = Math.round((i - cx) * stepPx);
        var stemImgMaxW = Math.min(1200, Math.max(320, Math.round(heroW * 2.2)));
        var url = escapeAttrUrl(heroStemImageUrl(placed[i].url, stemImgMaxW));
        var hcm = placed[i].heightCm;
        if (typeof hcm === 'string') hcm = parseHeightCmFromString(hcm);
        /*
         * Tallest in bouquet = STEM_TALL_PX tall; 55cm vs 104cm → ~53% of that pixel height.
         */
        var rH = 1;
        var stemPx = STEM_MIN_PX;
        if (hasAnyHeight && maxH > 0 && typeof hcm === 'number' && !isNaN(hcm) && hcm > 0) {
          rH = hcm / maxH;
          if (rH > 1) rH = 1;
          stemPx = Math.round(STEM_TALL_PX * rH);
          if (stemPx > STEM_PEAK_CAP) stemPx = STEM_PEAK_CAP;
          if (stemPx < stemPxFloor) stemPx = stemPxFloor;
        }
        /*
         * Scale width by rH too — same % width + object-fit made short stems fill width and look as tall as the center.
         */
        var wPct = stemW;
        if (hasAnyHeight && maxH > 0 && typeof hcm === 'number' && !isNaN(hcm) && hcm > 0) {
          wPct = Math.max(16, Math.min(52, Math.round(stemW * rH)));
        }
        var dist = Math.abs(i - cx);
        var angDeg = 0;
        /* Narrow: tiny positive lift — nudge up vs previous pass without returning to negative lift. */
        var liftPx = isNarrowHero ? Math.round(2 + 2 * (1 - narrowScale)) : -18;
        var originY = '100%';
        /* No tilt: keep stems upright. */
        var zStem = 30 + Math.round((n - 1) - 2 * dist);
        if (hasAnyHeight && maxH > 0 && i !== peakIdx) zStem += 14;
        parts.push(
          '<img class="config-bouquet-modal__hero-stem" src="' +
            url +
            '" alt="" loading="lazy" decoding="async" draggable="false" style="height:' +
            stemPx +
            'px;max-height:' +
            stemPx +
            'px;box-sizing:border-box;--stem-origin-y:' +
            originY +
            ';--stem-base-x-px:' +
            baseShiftX +
            'px;--stem-rot:' +
            angDeg +
            'deg;--stem-lift-px:' +
            liftPx +
            'px;--stem-w:' +
            wPct +
            '%;--stem-anchor-b:' +
            anchorB +
            '%;--stem-h-px:' +
            stemPx +
            'px;z-index:' +
            zStem +
            ';" />'
        );
      }
      stemsEl.innerHTML = parts.join('');
      /* Extra downward nudge of the whole stem layer on narrow hero (CSS: --hero-stems-nudge-up). */
      var nudgeUp = isNarrowHero ? Math.round(heroH * 0.024) : 0;
      stemsEl.style.setProperty('--hero-stems-nudge-up', nudgeUp + 'px');
    }

    function extractProductHeightHgt(product) {
      if (!product) return '';
      if (product._heightDisplay != null && String(product._heightDisplay).trim() !== '') {
        return String(product._heightDisplay).trim();
      }
      function valFromMaybe(mf) {
        if (mf == null) return '';
        if (typeof mf === 'object' && mf.value != null && String(mf.value).trim() !== '') {
          return String(mf.value).trim();
        }
        if (typeof mf === 'string' || typeof mf === 'number') return String(mf).trim();
        return '';
      }
      var m = product.metafields;
      if (m && typeof m === 'object' && !Array.isArray(m)) {
        if (m.cus !== undefined) {
          var cus = m.cus;
          if (cus && typeof cus === 'object' && cus.hgt !== undefined) {
            var hv = valFromMaybe(cus.hgt);
            if (hv) return hv;
          }
        }
        var flat = m['cus.hgt'];
        if (flat !== undefined && String(flat).trim() !== '') {
          return valFromMaybe(flat) || String(flat).trim();
        }
      }
      if (Array.isArray(m)) {
        for (var i = 0; i < m.length; i++) {
          var row = m[i];
          if (!row) continue;
          if (row.namespace === 'cus' && row.key === 'hgt') {
            var v = row.value !== undefined ? row.value : row;
            if (v != null && String(v).trim() !== '') return String(v).trim();
          }
        }
      }
      var single = product.metafield;
      if (single && single.namespace === 'cus' && single.key === 'hgt' && single.value != null) {
        var sv = String(single.value).trim();
        if (sv) return sv;
      }
      return '';
    }

    function applyHeightMapToProducts(products, map) {
      if (!products || !map || typeof map !== 'object') return;
      for (var i = 0; i < products.length; i++) {
        var p = products[i];
        if (!p || !p.handle) continue;
        var h = map[p.handle];
        if (h != null && String(h).trim() !== '') {
          p._heightDisplay = String(h).trim();
        }
      }
    }

    function getEmbeddedHeightMap() {
      var el = document.getElementById('config-bouquet-heights-embedded');
      if (!el) return null;
      try {
        return JSON.parse(el.textContent.trim());
      } catch (e) {
        return null;
      }
    }

    function buildRowActions(variant) {
      var vid = String(variant.id);
      var key = vid;
      var sel = bouquetSelections[key];
      var total = sumBouquet().count;
      var atLimit = total >= BOUQUET_MAX_FLOWERS;
      var canAddMore = variant.available !== false && !atLimit;
      if (sel && sel.quantity > 0) {
        return (
          '<div class="config-bouquet-modal__product-row-qty">' +
          '<button type="button" class="config-bouquet-modal__qty-trash" data-config-bouquet-line-remove="' +
          vid +
          '" aria-label="Remove from bouquet">' +
          iconTrash +
          '</button>' +
          '<span class="config-bouquet-modal__product-row-qty-val">' +
          sel.quantity +
          '</span>' +
          '<button type="button" class="config-bouquet-modal__qty-plus' +
          (canAddMore ? '' : ' config-bouquet-modal__qty-plus--disabled') +
          '" data-config-bouquet-line-plus="' +
          vid +
          '"' +
          (canAddMore ? '' : ' disabled') +
          ' aria-label="Add one">' +
          iconPlus +
          '</button></div>'
        );
      }
      if (variant.available === false) {
        return (
          '<button type="button" class="config-bouquet-modal__product-row-add config-bouquet-modal__product-row-add--sold" disabled data-config-bouquet-add-variant="' +
          vid +
          '" aria-disabled="true">Verkocht</button>'
        );
      }
      if (atLimit) {
        return (
          '<button type="button" class="config-bouquet-modal__product-row-add config-bouquet-modal__product-row-add--limit" disabled data-config-bouquet-add-variant="' +
          vid +
          '" aria-disabled="true" title="Maximum ' +
          BOUQUET_MAX_FLOWERS +
          ' flowers">Max</button>'
        );
      }
      return (
        '<button type="button" class="config-bouquet-modal__product-row-add" data-config-bouquet-add-variant="' +
        vid +
        '">Ajouter</button>'
      );
    }

    function renderProducts(products) {
      currentPanelProducts = products || [];
      var list = document.querySelector('[data-config-bouquet-products-list]');
      if (!list) return;
      var cur = getCurrency();
      list.innerHTML = currentPanelProducts
        .map(function (product) {
          var variant = pickVariant(product);
          if (!variant) return '';
          var img = productImageUrl(product, variant);
          var price = formatPrice(variant.price, cur);
          var priceNum = parseFloat(variant.price, 10) || 0;
          var compareRaw = variant.compare_at_price;
          var compareNum =
            compareRaw != null && compareRaw !== '' ? parseFloat(compareRaw, 10) : NaN;
          var compareHtml =
            !isNaN(compareNum) && compareNum > priceNum ?
              '<span class="config-bouquet-modal__product-row-compare-price">' +
              escapeHtml(formatPrice(compareRaw, cur)) +
              '</span>'
            : '';
          var title = escapeHtml(product.title);
          var heightRaw = extractProductHeightHgt(product);
          var heightHtml =
            heightRaw ?
              '<span class="config-bouquet-modal__product-row-height"> Height: ' + escapeHtml(heightRaw) + ' cm </span>'
            : '';
          var pid = escapeHtml(String(product.id));
          var vidRaw = String(variant.id);
          var vid = escapeHtml(vidRaw);
          var url = escapeHtml(product.url || '/products/' + product.handle);
          var imgTag = img
            ? '<img src="' + escapeAttrUrl(img) + '" alt="' + title + '" width="72" height="72" loading="lazy">'
            : '';
          var actions = buildRowActions(variant);
          return (
            '<article class="config-bouquet-modal__product-row" data-product-id="' +
            pid +
            '" data-config-bouquet-row-variant="' +
            vid +
            '">' +
            '<div class="config-bouquet-modal__product-row-media">' +
            imgTag +
            '<a class="config-bouquet-modal__product-row-zoom" href="' +
            url +
            '" target="_blank" rel="noopener noreferrer" aria-label="View product">' +
            '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M6 11.5a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11Z" stroke="currentColor" stroke-width="1.2"/><path d="M9 9 12.5 12.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>' +
            '</a></div>' +
            '<div class="config-bouquet-modal__product-row-info">' +
            '<span class="config-bouquet-modal__product-row-title">' +
            title +
            '</span>' +
            heightHtml +
            '<span class="config-bouquet-modal__product-row-price">' +
            escapeHtml(price) +
            compareHtml +
            '</span></div>' +
            '<div class="config-bouquet-modal__product-row-actions">' +
            actions +
            '</div></article>'
          );
        })
        .join('');
    }

    function refreshProductListFromCache() {
      if (currentPanelProducts.length) {
        renderProducts(currentPanelProducts);
      } else {
        var list = document.querySelector('[data-config-bouquet-products-list]');
        if (list) list.innerHTML = '';
      }
    }

    function updateBouquetSelectionScrollState(modal) {
      modal = modal || getModal();
      if (!modal || modal.hidden) return;
      var scroll = modal.querySelector('[data-config-bouquet-selection-list]');
      var prev = modal.querySelector('[data-config-bouquet-selection-prev]');
      var next = modal.querySelector('[data-config-bouquet-selection-next]');
      if (!scroll || !prev || !next) return;
      var max = scroll.scrollWidth - scroll.clientWidth;
      if (max <= 1) {
        prev.disabled = true;
        next.disabled = true;
        return;
      }
      prev.disabled = scroll.scrollLeft <= 1;
      next.disabled = scroll.scrollLeft >= max - 1;
    }

    function bindBouquetSelectionScrollOnce(modal) {
      modal = modal || getModal();
      if (!modal || modal.dataset.bouquetSelectionScrollBound === '1') return;
      var scroll = modal.querySelector('[data-config-bouquet-selection-list]');
      if (!scroll) return;
      modal.dataset.bouquetSelectionScrollBound = '1';
      scroll.addEventListener('scroll', function () {
        updateBouquetSelectionScrollState(modal);
      });
      if (typeof ResizeObserver !== 'undefined') {
        try {
          var ro = new ResizeObserver(function () {
            updateBouquetSelectionScrollState(modal);
          });
          ro.observe(scroll);
        } catch (err) {}
      }
    }

    function renderPickCard(key, line) {
      var vid = escapeHtml(key);
      var title = escapeHtml(line.title);
      var price = escapeHtml(line.priceDisplay);
      var img =
        line.imageUrl ?
          '<img src="' + escapeAttrUrl(line.imageUrl) + '" alt="" width="120" height="120" loading="lazy">'
        : '';
      var pq = line.quantity;
      var atMax = sumBouquet().count >= BOUQUET_MAX_FLOWERS;
      return (
        '<article class="config-bouquet-modal__pick-card" data-config-bouquet-pick="' +
        vid +
        '"><div class="config-bouquet-modal__pick-card-media">' +
        img +
        '<button type="button" class="config-bouquet-modal__pick-remove" data-config-bouquet-pick-remove="' +
        vid +
        '" aria-label="Remove">' +
        iconTrash +
        '</button></div><div class="config-bouquet-modal__pick-title">' +
        title +
        '</div><div class="config-bouquet-modal__pick-price">' +
        price +
        '</div><div class="config-bouquet-modal__pick-qty">' +
        '<button type="button" data-config-bouquet-pick-remove="' +
        vid +
        '" aria-label="Remove line">' +
        iconTrash +
        '</button><span class="config-bouquet-modal__pick-qty-val">' +
        pq +
        '</span><button type="button" data-config-bouquet-pick-plus="' +
        vid +
        '" aria-label="Add one"' +
        (atMax ? ' disabled' : '') +
        '>' +
        iconPlus +
        '</button></div></article>'
      );
    }

    function renderPickRowMobile(key, line) {
      var vid = escapeHtml(key);
      var title = escapeHtml(line.title);
      var price = escapeHtml(line.priceDisplay);
      var img =
        line.imageUrl ?
          '<img src="' +
            escapeAttrUrl(line.imageUrl) +
            '" alt="" width="56" height="56" loading="lazy">'
        : '';
      var pq = line.quantity;
      var atMax = sumBouquet().count >= BOUQUET_MAX_FLOWERS;
      var decBtn =
        pq > 1 ?
          '<button type="button" class="config-bouquet-modal__pick-row-mobile-dec" data-config-bouquet-pick-minus="' +
            vid +
            '" aria-label="Remove one"><span aria-hidden="true" style="font-size:18px;line-height:1;font-weight:600">−</span></button>'
        : '<button type="button" class="config-bouquet-modal__pick-row-mobile-dec" data-config-bouquet-pick-remove="' +
            vid +
            '" aria-label="Remove">' +
            iconTrash +
            '</button>';
      return (
        '<article class="config-bouquet-modal__pick-row-mobile">' +
        '<div class="config-bouquet-modal__pick-row-mobile-thumb">' +
        img +
        '</div><div class="config-bouquet-modal__pick-row-mobile-meta">' +
        '<div class="config-bouquet-modal__pick-row-mobile-title">' +
        title +
        '</div><div class="config-bouquet-modal__pick-row-mobile-price">' +
        price +
        '</div></div><div class="config-bouquet-modal__pick-row-mobile-qty">' +
        decBtn +
        '<span class="config-bouquet-modal__pick-row-mobile-qty-val">' +
        pq +
        '</span><button type="button" data-config-bouquet-pick-plus="' +
        vid +
        '" aria-label="Add one"' +
        (atMax ? ' disabled' : '') +
        '>' +
        iconPlus +
        '</button></div></article>'
      );
    }

    function openMobileBouquetSelection() {
      var el = document.getElementById('mobile-config-bouquet-modal__bouquet-selection');
      if (!el) return;
      updateBouquetChrome();
      el.removeAttribute('hidden');
      el.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () {
        el.classList.add('is-open');
      });
    }

    function closeMobileBouquetSelection() {
      var el = document.getElementById('mobile-config-bouquet-modal__bouquet-selection');
      if (!el) return;
      el.classList.remove('is-open');
      window.setTimeout(function () {
        el.setAttribute('hidden', '');
        el.setAttribute('aria-hidden', 'true');
      }, 340);
    }

    function closeMobileBouquetSelectionImmediate() {
      var el = document.getElementById('mobile-config-bouquet-modal__bouquet-selection');
      if (!el) return;
      el.classList.remove('is-open');
      el.setAttribute('hidden', '');
      el.setAttribute('aria-hidden', 'true');
    }

    function updateBouquetChrome() {
      var modal = getModal();
      if (!modal) return;
      var oldSig = modal.dataset.aiPreviewSelectionSignature || '';
      var newSig = buildSelectionSignature();
      if (modal.getAttribute('data-ai-preview-active') === 'true' && oldSig && oldSig !== newSig) {
        clearAiPreview({ keepStatus: true });
        setAiStatus('Selectie gewijzigd. Genereer opnieuw voor nieuwe AI preview.', false);
      }
      var s = sumBouquet();
      modal.setAttribute('data-bouquet-count', String(s.count));
      var cur = getCurrency();
      var preview = modal.querySelector('[data-config-bouquet-preview]');
      var pill = modal.querySelector('[data-config-bouquet-count-pill]');
      var pillText = modal.querySelector('[data-config-bouquet-count-pill-text]');
      var listEl = modal.querySelector('[data-config-bouquet-selection-list]');
      var selectionWrap = modal.querySelector('[data-config-bouquet-selection-wrap]');
      var lblEls = modal.querySelectorAll('[data-config-bouquet-footer-total-label]');
      var priceEls = modal.querySelectorAll('[data-config-bouquet-footer-price]');
      var cartBtns = modal.querySelectorAll('[data-config-bouquet-footer-cart]');
      var stripEls = modal.querySelectorAll('[data-config-bouquet-strip-text]');
      var editOpenBtns = modal.querySelectorAll('[data-config-bouquet-mobile-selection-open]');
      var mobileListEl = modal.querySelector('[data-config-bouquet-mobile-selection-list]');
      var mobileSubEl = modal.querySelector('[data-config-bouquet-mobile-selection-sub]');
      var aiControlsEls = modal.querySelectorAll('[data-config-bouquet-ai-controls]');

      if (preview) {
        if (s.count > 0) {
          preview.setAttribute('data-has-selections', 'true');
        } else {
          preview.removeAttribute('data-has-selections');
        }
      }
      if (pill && pillText) {
        if (s.count > 0) {
          pill.hidden = false;
          pill.setAttribute('aria-hidden', 'false');
          pillText.textContent = s.count + (s.count === 1 ? ' fleur' : ' fleurs') + ' dans le bouquet';
        } else {
          pill.hidden = true;
          pill.setAttribute('aria-hidden', 'true');
          pillText.textContent = '';
        }
      }
      if (selectionWrap) {
        selectionWrap.hidden = s.count === 0;
      }
      if (listEl) {
        listEl.innerHTML = Object.keys(bouquetSelections)
          .filter(function (k) {
            return bouquetSelections[k].quantity > 0;
          })
          .map(function (k) {
            return renderPickCard(k, bouquetSelections[k]);
          })
          .join('');
        if (s.count > 0) {
          bindBouquetSelectionScrollOnce(modal);
          requestAnimationFrame(function () {
            updateBouquetSelectionScrollState(modal);
          });
        }
      }
      if (mobileListEl) {
        mobileListEl.innerHTML = Object.keys(bouquetSelections)
          .filter(function (k) {
            return bouquetSelections[k].quantity > 0;
          })
          .map(function (k) {
            return renderPickRowMobile(k, bouquetSelections[k]);
          })
          .join('');
      }
      if (mobileSubEl) {
        mobileSubEl.textContent =
          s.count > 0 ?
            s.count + (s.count === 1 ? ' fleur' : ' fleurs') + ' dans le bouquet'
          : '';
      }
      if (editOpenBtns && editOpenBtns.length > 0) {
        editOpenBtns.forEach(function (btn) {
          if (s.count > 0) {
            btn.hidden = false;
          } else {
            btn.hidden = true;
          }
        });
        if (s.count === 0) {
          var mobPanel = document.getElementById('mobile-config-bouquet-modal__bouquet-selection');
          if (mobPanel && mobPanel.classList.contains('is-open')) {
            closeMobileBouquetSelectionImmediate();
          }
        }
      }
      if (lblEls && priceEls && lblEls.length > 0 && priceEls.length > 0) {
        if (s.count > 0) {
          var lblText =
            'Total (' + s.count + (s.count === 1 ? ' fleur' : ' fleurs') + ')';
          var priceText = formatPrice(String(s.total), cur);
          lblEls.forEach(function (el) {
            el.textContent = lblText;
          });
          priceEls.forEach(function (el) {
            el.textContent = priceText;
          });
        } else {
          lblEls.forEach(function (el) {
            el.textContent = 'Total';
          });
          priceEls.forEach(function (el) {
            el.textContent = '—';
          });
        }
      }
      if (cartBtns && cartBtns.length > 0) {
        cartBtns.forEach(function (btn) {
          btn.disabled = s.count === 0;
        });
      }
      if (stripEls && stripEls.length > 0) {
        var stripText =
          s.count > 0 ?
            s.count + (s.count === 1 ? ' fleur' : ' fleurs') + ' dans le bouquet'
          : 'Commencez par ajouter des produits pour visualiser votre bouquet.';
        stripEls.forEach(function (el) {
          el.textContent = stripText;
        });
      }
      if (aiControlsEls && aiControlsEls.length) {
        aiControlsEls.forEach(function (aiControlsEl) {
          if (s.count === 0) {
            aiControlsEl.hidden = true;
            return;
          }
          aiControlsEl.hidden = false;
        });
      }
      updateAiControls();
      updateBouquetHeroPreview();
    }

    function openProductsPanel(handle) {
      var panel = getProductsPanel();
      if (!panel) return;
      currentPanelCollectionHandle = handle || '';
      var loading = document.querySelector('[data-config-bouquet-products-loading]');
      var errEl = document.querySelector('[data-config-bouquet-products-error]');
      var list = document.querySelector('[data-config-bouquet-products-list]');
      var chips = document.querySelector('[data-config-bouquet-filter-chips]');
      closeColorDrawerImmediate();
      allPanelProducts = [];
      colorFacets = [];
      collectionColorOptionIndexOverride = null;
      colorFacetsFromStorefrontFacets = false;
      selectedColorKeys = [];
      if (chips) {
        chips.innerHTML = '';
        chips.hidden = true;
      }
      updateColorFilterButtonUi();
      setColorFilterButtonsEnabled(false);
      if (loading) loading.hidden = false;
      if (errEl) {
        errEl.hidden = true;
        errEl.textContent = '';
      }
      if (list) list.innerHTML = '';

      panel.removeAttribute('hidden');
      panel.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () {
        panel.classList.add('is-open');
        var heroBar = document.querySelector('[data-config-bouquet-hero-products-bar]');
        if (heroBar) heroBar.setAttribute('aria-hidden', 'false');
        try {
          var modal = getModal();
          var heroBack =
            modal &&
            modal.querySelector('[data-config-bouquet-hero-products-bar] [data-config-bouquet-products-back]');
          if (window.matchMedia('(max-width: 768px)').matches && heroBack) {
            heroBack.focus();
          } else {
            panel.querySelector('[data-config-bouquet-products-back]')?.focus();
          }
        } catch (e) {}
      });

      getEligibleCollectionProducts(handle)
        .then(function (products) {
          if (loading) loading.hidden = true;
          if (!products.length && list) {
            list.innerHTML =
              '<p class="config-bouquet-modal__products-panel-error">Deze collectie bevat geen producten met de tag "BoeketConfigurator" die op voorraad zijn.</p>';
            return;
          }
          applyHeightMapToProducts(products, getEmbeddedHeightMap());
          allPanelProducts = products;
          collectionColorOptionIndexOverride = null;
          colorFacetsFromStorefrontFacets = false;
          var cfgForFacets = getBouquetSwatchConfig();
          var facetColorRows =
            cfgForFacets.facetColorsByCollection &&
            cfgForFacets.facetColorsByCollection[handle];
          if (facetColorRows && facetColorRows.length) {
            colorFacets = normalizeFacetColorRows(facetColorRows);
            colorFacetsFromStorefrontFacets = true;
          } else {
            colorFacets = buildColorFacets(products);
            if (!colorFacets.length && products.length) {
              var inferredIdx = inferColorOptionIndexForCollection(products);
              if (inferredIdx >= 0) {
                collectionColorOptionIndexOverride = inferredIdx;
                colorFacets = buildColorFacets(products);
              }
            }
          }
          selectedColorKeys = [];
          setColorFilterButtonsEnabled(true);
          updateColorFilterButtonUi();
          renderFilterChips();
          renderProducts(products);
        })
        .catch(function (err) {
          if (loading) loading.hidden = true;
          if (errEl) {
            errEl.hidden = false;
            var msg = err && err.message ? err.message : 'Er is iets misgegaan.';
            errEl.innerHTML =
              msg +
              '<button type="button" class="config-bouquet-modal__products-retry" data-config-bouquet-products-retry>Opnieuw proberen</button>';
          }
        });
    }

    function openModal(source) {
      var modal = getModal();
      if (!modal) return;
      if (!modal.hidden) return;
      modal.hidden = false;
      trackPopupOpen(source);
      document.body.classList.add('config-bouquet-modal-open');
      syncCartCount();
      hydrateCollectionCountBadges();
      var discoverCard = modal.querySelector(
        '.config-bouquet-modal__discover[data-config-bouquet-collection-handle]'
      );
      var discoverHandle =
        discoverCard && discoverCard.getAttribute('data-config-bouquet-collection-handle');
      if (discoverHandle) {
        openProductsPanel(discoverHandle);
      }
      try {
        modal.querySelector('.config-bouquet-modal__back')?.focus();
      } catch (e) {}
    }

    function closeModal() {
      closeProductsPanel();
      resetBouquetConfigurator();
      var modal = getModal();
      if (!modal) return;
      modal.hidden = true;
      document.body.classList.remove('config-bouquet-modal-open');
      try {
        getOpenButton()?.focus();
      } catch (e) {}
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('#config-bouquet')) {
        e.preventDefault();
        openModal('button');
        return;
      }
      if (e.target.closest && e.target.closest('[data-config-bouquet-close]')) {
        closeModal();
        return;
      }
      if (e.target.closest && e.target.closest('#config-bouquet-cart-trigger')) {
        e.preventDefault();
        closeModal();
        requestAnimationFrame(function () {
          document.getElementById('cart-drawer-toggle')?.click();
        });
        return;
      }
      var modalEl = getModal();
      if (modalEl && !modalEl.hidden) {
        var drawerRoot = document.getElementById('config-bouquet-color-drawer');
        if (drawerRoot && drawerRoot.contains(e.target)) {
          if (e.target.closest && e.target.closest('[data-config-bouquet-color-drawer-close]')) {
            e.preventDefault();
            closeColorDrawer();
            return;
          }
          if (e.target.closest && e.target.closest('[data-config-bouquet-color-drawer-apply]')) {
            e.preventDefault();
            onColorDrawerApply();
            return;
          }
        }
        var chipRm = e.target.closest('[data-config-bouquet-filter-chip-remove]');
        if (
          chipRm &&
          getProductsPanel() &&
          getProductsPanel().contains(chipRm)
        ) {
          e.preventDefault();
          var rk = chipRm.getAttribute('data-config-bouquet-filter-chip-remove');
          var kDec = rk ? decodeURIComponent(rk) : '';
          selectedColorKeys = selectedColorKeys.filter(function (x) {
            return x !== kDec;
          });
          applyColorFiltersAndRender();
          return;
        }
        var cfBtn = e.target.closest('[data-config-bouquet-color-filter]');
        if (cfBtn && modalEl.contains(cfBtn) && !cfBtn.disabled) {
          e.preventDefault();
          openColorDrawer();
          return;
        }
        var selPrev = e.target.closest('[data-config-bouquet-selection-prev]');
        if (selPrev && modalEl.contains(selPrev)) {
          e.preventDefault();
          var scP = modalEl.querySelector('[data-config-bouquet-selection-list]');
          if (scP && !selPrev.disabled) {
            var dx = Math.max(140, Math.floor(scP.clientWidth * 0.65));
            scP.scrollBy({ left: -dx, behavior: 'smooth' });
            window.setTimeout(function () {
              updateBouquetSelectionScrollState(modalEl);
            }, 380);
          }
          return;
        }
        var selNext = e.target.closest('[data-config-bouquet-selection-next]');
        if (selNext && modalEl.contains(selNext)) {
          e.preventDefault();
          var scN = modalEl.querySelector('[data-config-bouquet-selection-list]');
          if (scN && !selNext.disabled) {
            var dxN = Math.max(140, Math.floor(scN.clientWidth * 0.65));
            scN.scrollBy({ left: dxN, behavior: 'smooth' });
            window.setTimeout(function () {
              updateBouquetSelectionScrollState(modalEl);
            }, 380);
          }
          return;
        }
        var card = e.target.closest(
          '.config-bouquet-modal__flower-card[data-config-bouquet-collection-handle], .config-bouquet-modal__discover[data-config-bouquet-collection-handle]'
        );
        if (card) {
          e.preventDefault();
          var h = card.getAttribute('data-config-bouquet-collection-handle');
          if (h) openProductsPanel(h);
          return;
        }
        if (e.target.closest && e.target.closest('[data-config-bouquet-products-back]')) {
          e.preventDefault();
          closeProductsPanel();
          return;
        }
        var retryBtn = e.target.closest('[data-config-bouquet-products-retry]');
        if (retryBtn && getProductsPanel() && getProductsPanel().contains(retryBtn)) {
          e.preventDefault();
          if (currentPanelCollectionHandle) openProductsPanel(currentPanelCollectionHandle);
          return;
        }
        var addBtn = e.target.closest('[data-config-bouquet-add-variant]');
        if (addBtn && getProductsPanel() && getProductsPanel().contains(addBtn)) {
          e.preventDefault();
          if (addBtn.disabled) return;
          var vAdd = addBtn.getAttribute('data-config-bouquet-add-variant');
          if (vAdd) addVariantToBouquet(vAdd);
          return;
        }
        var rm = e.target.closest('[data-config-bouquet-line-remove]');
        if (rm && getProductsPanel() && getProductsPanel().contains(rm)) {
          e.preventDefault();
          removeVariantFromBouquet(rm.getAttribute('data-config-bouquet-line-remove'));
          return;
        }
        var pl = e.target.closest('[data-config-bouquet-line-plus]');
        if (pl && getProductsPanel() && getProductsPanel().contains(pl)) {
          e.preventDefault();
          if (pl.disabled) return;
          incrementVariantInBouquet(pl.getAttribute('data-config-bouquet-line-plus'));
          return;
        }
        var prm = e.target.closest('[data-config-bouquet-pick-remove]');
        if (prm && modalEl.contains(prm)) {
          e.preventDefault();
          removeVariantFromBouquet(prm.getAttribute('data-config-bouquet-pick-remove'));
          return;
        }
        var pmin = e.target.closest('[data-config-bouquet-pick-minus]');
        if (pmin && modalEl.contains(pmin)) {
          e.preventDefault();
          decrementVariantInBouquet(pmin.getAttribute('data-config-bouquet-pick-minus'));
          return;
        }
        var ppl = e.target.closest('[data-config-bouquet-pick-plus]');
        if (ppl && modalEl.contains(ppl)) {
          e.preventDefault();
          if (ppl.disabled) return;
          incrementVariantInBouquet(ppl.getAttribute('data-config-bouquet-pick-plus'));
          return;
        }
        var mobOpen = e.target.closest('[data-config-bouquet-mobile-selection-open]');
        if (mobOpen && modalEl.contains(mobOpen)) {
          e.preventDefault();
          openMobileBouquetSelection();
          return;
        }
        var mobClose = e.target.closest('[data-config-bouquet-mobile-selection-close]');
        if (mobClose && modalEl.contains(mobClose)) {
          e.preventDefault();
          closeMobileBouquetSelection();
          return;
        }
        var aiPreviewBtn = e.target.closest('[data-config-bouquet-ai-preview]');
        if (aiPreviewBtn && modalEl.contains(aiPreviewBtn)) {
          e.preventDefault();
          if (aiPreviewBtn.disabled) return;
          requestAiBouquetPreview();
          return;
        }
      }
    });

    document.addEventListener('keydown', function (e) {
      var dColor = document.getElementById('config-bouquet-color-drawer');
      if (
        dColor &&
        dColor.classList.contains('is-open') &&
        (e.key === 'Enter' || e.key === ' ') &&
        e.target &&
        e.target.closest &&
        e.target.closest('.close-bq-colors')
      ) {
        e.preventDefault();
        closeColorDrawer();
        return;
      }
      if (e.key !== 'Escape') return;
      var modal = getModal();
      if (!modal || modal.hidden) return;
      var dMob = document.getElementById('mobile-config-bouquet-modal__bouquet-selection');
      if (dMob && dMob.classList.contains('is-open')) {
        closeMobileBouquetSelection();
        return;
      }
      var d = document.getElementById('config-bouquet-color-drawer');
      if (d && d.classList.contains('is-open')) {
        closeColorDrawer();
        return;
      }
      var panel = getProductsPanel();
      if (panel && panel.classList.contains('is-open')) {
        closeProductsPanel();
        return;
      }
      closeModal();
    });

    function getThemeSectionsToRender() {
      return [
        { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
        { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
        { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' },
      ];
    }

    function getSectionInnerHTML(html, selector) {
      var rootSelector = selector || '.shopify-section';
      var parsed = new DOMParser().parseFromString(html || '', 'text/html');
      var selected = parsed.querySelector(rootSelector);
      return selected ? selected.innerHTML : '';
    }

    function renderThemeCartContents(parsedState) {
      var sections = getThemeSectionsToRender();
      sections.forEach(function (section) {
        var sectionEl = document.getElementById(section.id);
        if (!sectionEl || !parsedState || !parsedState[section.section]) return;
        var elementToReplace = sectionEl.querySelector(section.selector) || sectionEl;
        elementToReplace.innerHTML = getSectionInnerHTML(parsedState[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') new CartDrawer();
        if (typeof Cart !== 'undefined') new Cart().renderContents(parsedState);
      });

      var drawer = document.getElementById('Cart-Drawer');
      if (drawer) {
        document.body.classList.add('open-cc');
        drawer.classList.add('active');
        document.dispatchEvent(new CustomEvent('cart-drawer:open'));
      }
    }

    function refreshThemeCartSections() {
      var sections = 'main-cart,cart-drawer,cart-bubble';
      return fetch(window.location.pathname + '?sections=' + sections)
        .then(function (response) {
          return response.text();
        })
        .then(function (state) {
          var parsedState = JSON.parse(state);
          renderThemeCartContents(parsedState);
        });
    }

    document.addEventListener('click', function (e) {
      var checkout = e.target.closest('[data-config-bouquet-footer-cart]');
      if (!checkout || checkout.disabled) return;
      var modalCk = getModal();
      if (!modalCk || modalCk.hidden || !modalCk.contains(checkout)) return;
      e.preventDefault();
      if (!window.theme || !theme.routes || !theme.routes.cart_add_url) return;
      var popupSourceProperties = {
        _bouquet_popup_source: 'config_bouquet_popup',
        _bouquet_popup_used: 'true',
      };
      var items = Object.keys(bouquetSelections)
        .filter(function (k) {
          return bouquetSelections[k].quantity > 0;
        })
        .map(function (k) {
          return {
            id: bouquetSelections[k].variantId,
            quantity: bouquetSelections[k].quantity,
            properties: popupSourceProperties,
          };
        });
      if (!items.length) return;
      checkout.disabled = true;
      fetch(theme.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items: items }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (res) {
          if (res && res.status) throw new Error();
          return refreshThemeCartSections().then(function () {
            clearBouquetStaging();
            document.dispatchEvent(
              new CustomEvent('cart:item-added', {
                detail: {
                  product: res && res.items && res.items.length ? res.items[0] : res,
                },
              })
            );
            syncCartCount();
          });
        })
        .catch(function () {})
        .then(function () {
          checkout.disabled = sumBouquet().count === 0;
        });
    });

    document.addEventListener('cart:refresh', syncCartCount);
    document.addEventListener('cart:item-added', syncCartCount);

    function bindColorDrawerChangeOnce() {
      var d = document.getElementById('config-bouquet-color-drawer');
      if (!d || d.dataset.bouquetColorChangeBound === '1') return;
      d.dataset.bouquetColorChangeBound = '1';
      d.addEventListener('change', function (e) {
        var t = e.target;
        if (t && t.matches && t.matches('input[data-config-bouquet-color-option]')) {
          updateDrawerApplyButtonLabel();
        }
      });
    }

    function runBouquetDeferredInit() {
      bindColorDrawerChangeOnce();
      syncCartCount();
      updateBouquetChrome();
      hydrateCollectionCountBadges();
      var modal = getModal();
      if (modal) {
        var closeBtn = modal.querySelector('[data-config-bouquet-ai-popup-close]');
        if (closeBtn) {
          closeBtn.addEventListener('click', function () {
            hideAiProgressUi();
          });
        }
      }
    }

    runBouquetDeferredInit();
    window.__configBouquetModalReady = true;
    if (window.__configBouquetPendingOpen) {
      window.__configBouquetPendingOpen = false;
      openModal('direct_link');
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runBouquetDeferredInit, { once: true });
    }
    window.addEventListener('load', runBouquetDeferredInit, { once: true });
  })();
